export default __webpack_public_path__ + "21d80b0819229eeeeb5d014897ca0f3c.png";